import React from 'react';
import { makeStyles, AppBar, Logo } from '@smile-next/uikit';

const useStyles = makeStyles(() => ({
    root: {},
    logo: {
        display: 'flex',
        flex: 1,
    },
}));

export const AppHeader: React.FC = () => {
    const classes = useStyles();

    return (
        <AppBar>
            <a className={classes.logo} href="/app/login">
                <Logo />
            </a>
        </AppBar>
    );
};
